import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dismissBtn", "confirm1"]
  static values  = { dismissUrl: String }

  dismissStep1() {
    this.dismissBtnTarget.classList.add("hidden")
    this.confirm1Target.classList.remove("hidden")
  }

  cancelDismiss() {
    this.confirm1Target.classList.add("hidden")
    this.dismissBtnTarget.classList.remove("hidden")
  }

  async confirmDismiss() {
    await fetch(this.dismissUrlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Accept": "application/json"
      }
    })
    this.element.remove()
  }
}
